import * as d3 from "d3";
import { calcBoundedLimit } from "./utils";

/**
 * @this {import('alpinejs').AlpineComponent}
 */
export default function proportionalCircleChart(options) {
  let boundedHeight;
  let boundedWidth;
  let data;
  let maxRadius, minRadius;
  let c, r, color;
  let show = false;

  const scales = (xIndex, yIndex, colorRange) => {
    maxRadius = Math.min(
      boundedWidth / data.length,
      boundedHeight / data.length
    );
    minRadius = maxRadius / 4;
    c = d3.scaleBand().range([0, boundedWidth]);
    c.domain((data || []).map((d) => d[xIndex]));

    r = d3.scaleLinear().range([minRadius, maxRadius]);
    color = d3
      .scaleQuantile()
      .domain([
        d3.min(data || [], (d) => +d[yIndex]) || 0,
        d3.max(data || [], (d) => +d[yIndex]) || 0,
      ])
      .range(colorRange);

    r.domain([
      d3.min(data || [], (d) => +d[yIndex]) || 0,
      d3.max(data || [], (d) => +d[yIndex]) || 0,
    ]);
  };

  const initializeSvg = (width, height, margin) => {
    const { boundedHeight: bh, boundedWidth: bw } = calcBoundedLimit(
      width,
      height,
      margin
    );
    boundedHeight = bh;
    boundedWidth = bw;
  };

  return {
    ...options,
    async init() {
      data = await d3.csv(options.url);

      this.$watch("width", () => {
        this.show = false;
        // on re-calcule tout
        initializeSvg(this.width, this.height, this.margin);
        scales(this.xIndex, this.yIndex, this.colorRange);
        this.$nextTick(() => (this.show = true));
      });
    },
    translateChart() {
      return `translate(${this.margin.left},${this.margin.top})`;
    },
    translateCircles() {
      return `translate(${r(data[0].valeur)},${boundedHeight - maxRadius})`;
    },
    translateText() {
      return `translate(${r(data[0].valeur)}, 24)`;
    },
    splitText(str, cordlen) {
      const temp = str
        .replace("-", "- ")
        .split(" ")
        .reduce(
          (acc, c) => {
            const currIndex = acc.length - 1;

            const currLen = acc[currIndex].join(" ").length;

            if (currLen + c.length > cordlen) {
              acc.push([c]);
            } else {
              acc[currIndex].push(c);
            }

            return acc;
          },
          [[]]
        );

      const out = temp
        .map((arr) => arr.join(" ").replace("- ", "-"))
        .filter((e) => e !== "");
      return out;
    },
    get data() {
      return data;
    },
    get c() {
      return c;
    },
    get r() {
      return r;
    },
    get color() {
      return color;
    },
    get show() {
      return show;
    },
    set show(s) {
      show = s;
    },
    get boundedHeight() {
      return boundedHeight;
    },
    get boundedWidth() {
      return boundedWidth;
    },
  };
}
